/** GUEST - 1, CUSTOMER - 2, ENGINEER - 3, ADMIN - 4, SUPERADMIN - 5 */
export const ROLE_IDS = {
  GUEST: 1,
  CUSTOMER: 2,
  ENGINEER: 3,
  ADMIN: 4,
  SUPERADMIN: 5,
};

/** Roles allowed to sign in to this web portal */
export const PORTAL_ROLE_IDS = new Set([
  ROLE_IDS.ADMIN,
  ROLE_IDS.SUPERADMIN,
]);

export function normalizeUserRoleId(userDetails) {
  if (!userDetails || typeof userDetails !== 'object') return null;
  const fromId = userDetails.roleId ?? userDetails.role?.roleId;
  if (fromId != null && fromId !== '') {
    const n = Number(fromId);
    if (Number.isFinite(n)) return n;
  }
  const nameRaw =
    userDetails.roleName
    ?? userDetails.role?.roleName
    ?? (typeof userDetails.role === 'string' ? userDetails.role : null);
  const name = (nameRaw || '').toString().trim().toUpperCase().replace(/\s+/g, '_');
  if (name === 'ENGINEER') return ROLE_IDS.ENGINEER;
  if (name === 'ADMIN') return ROLE_IDS.ADMIN;
  if (name === 'SUPERADMIN' || name === 'SUPER_ADMIN') return ROLE_IDS.SUPERADMIN;
  return null;
}

export function isPortalUser(userDetails) {
  const id = normalizeUserRoleId(userDetails);
  return id != null && PORTAL_ROLE_IDS.has(id);
}

export function getHomeRouteForRole(roleId) {
  return '/admin';
}

